export const compareTextCaseInsensitive = (
  valueA: string | null | undefined,
  valueB: string | null | undefined,
) =>
  (valueA ?? "").localeCompare(valueB ?? "", undefined, {
    sensitivity: "base",
  });
